export class InvalidTelemetryUnitIdError extends Error {
    constructor(message: string = 'Invalid telemetry unit Id') {
        super(message);
        this.name = 'InvalidTelemetryUnitIdError';
        Object.setPrototypeOf(this, InvalidTelemetryUnitIdError.prototype);
    }
}
